/* offerFraming.ts — shared bits for the Offer-framing editor surface (ADR 0056).

   Offer framing is operator-authored guidance for HOW the AI words a paid reveal
   (the "offer") on a SALE rung. It is authored in three places, all importing the
   default text from here so it is defined exactly once in web_console:
     • the Auto panel account-level default   (SalesLadderSubTab / AutoOfferFraming)
     • the Fixed rung editor, sale rungs only  (RungEditor)
     • the Adaptable stage editor, sale stages (Content/salesB/editorKit)

   OFFER_FRAMING_DEFAULT mirrors the runtime constant in
   bigdayz.new/response_generation_with_graph/offer_framing.py VERBATIM, and is
   DISPLAY-ONLY here (placeholder / prefill). An unedited account never persists
   text — the accounts column stays NULL and the per-step key is absent — so the
   Python constant is the single behavioural source of the default. A drift here
   can only make this placeholder stale, never change what the AI actually does;
   keep it in sync if the Python constant changes. */

export const OFFER_FRAMING_DEFAULT =
  'Frame this reveal as the next chapter of the story, not a pitch. Write from ' +
  'pure desire to be seen by her — you want her eyes on you, you want her to see ' +
  'this side of you. Do NOT mention the price, PPV, unlocking, or that anything ' +
  '"costs" money or is an "offer"; the lock and the price are handled for you, so ' +
  'your words are only longing and invitation. Make it feel inevitable after ' +
  'everything that just happened.';

/** Soft length cap for the editor textareas. Offer framing renders every turn in
 *  the uncached variable section (ADR 0056 § Length), so it carries a sane cap. */
export const OFFER_FRAMING_MAX_LEN = 800;
